export const TEST_ACTION = 'TEST_ACTION';
export const TOGGLE_STRATEGY = 'TOGGLE_STRATEGY';
export const LOGOUT_USER = 'LOGOUT_USER';
export const SET_STRATEGY_ID = 'SET_STRATEGY_ID';
export const SET_STRATEGY_DATA = 'SET_STRATEGY_DATA';
export const SET_STRATEGY_LIST = 'SET_STRATEGY_LIST';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';

export const START_BACKTEST_REQUEST = 'START_BACKTEST_REQUEST';
export const START_BACKTEST_SUCCESS = 'START_BACKTEST_SUCCESS';
export const START_BACKTEST_FAILED = 'START_BACKTEST_FAILED';

export const USER_LOGGED_IN_REQUEST = 'USER_LOGGED_IN_REQUEST';
export const USER_LOGGED_IN_SUCCESS = 'USER_LOGGED_IN_SUCCESS';
export const USER_LOGGED_IN_FAILED = 'USER_LOGGED_IN_FAILED';

export const VERIFY_TOKEN_REQUEST = 'VERIFY_TOKEN_REQUEST';
export const VERIFY_TOKEN_SUCCESS = 'VERIFY_TOKEN_SUCCESS';
export const VERIFY_TOKEN_FAILED = 'VERIFY_TOKEN_FAILED';

export const FILTERED_BACKTEST_DATA_REQUEST = 'FILTERED_BACKTEST_DATA_REQUEST';
export const FILTERED_BACKTEST_DATA_SUCCESS = 'FILTERED_BACKTEST_DATA_SUCCESS';
export const  FILTERED_BACKTEST_DATA_LOADER = ' FILTERED_BACKTEST_DATA_LOADER';

export const FILTERED_EXPIRY_DATA = 'FILTERED_EXPIRY_DATA,';

export const GROUPING_BY_EXPIRE = 'GROUPING_BY_EXPIRE,';

export const CHECKED_FILTER_DATA = 'CHECKED_FILTER_DATA';
// export const GROUPING_BY_EXPIRE = 'GROUPING_BY_EXPIRE,';

export const MAX_DRAWDOWN_DATA = 'MAX_DRAWDOWN_DATA';
export const initialIsChecked = 'initialIsChecked';

export const START_DATE_GRAPH_REQUEST = 'START_DATE_GRAPH_REQUEST';
export const START_DATE_GRAPH_SUCCESS = 'START_DATE_GRAPH_SUCCESS';
export const START_DATE_GRAPH_FAILED = 'START_DATE_GRAPH_FAILED';

export const CHECKED_POSITIONAL_FILTER_DATA = 'CHECKED_POSITIONAL_FILTER_DATA';

export const START_MANUAL_BACKTEST_REQUEST = 'START_BACKTEST_REQUEST';
export const START_MANUAL_BACKTEST_SUCCESS = 'START_BACKTEST_SUCCESS';
export const START_MANUAL_BACKTEST_FAILED = 'START_BACKTEST_FAILED';

export const START_LOTSIZE_REQUEST = 'START_LOTSIZE_REQUEST';
export const START_LOTSIZE_SUCCESS = 'START_LOTSIZE_SUCCESS';
export const START_LOTSIZE_FAILED = 'START_LOTSIZE_FAILED';

export const GET_OPTION_CHAIN_REQUEST = 'GET_OPTION_CHAIN_REQUEST';
export const GET_OPTION_CHAIN_SUCCESS = 'GET_OPTION_CHAIN_SUCCESS';
export const GET_OPTION_CHAIN_FAILED = 'GET_OPTION_CHAIN_FAILED';

export const SET_VALIDATION_ERROR = 'SET_VALIDATION_ERROR';

export const GET_PAY_OFF_REQUEST = 'GET_PAY_OFF_REQUEST';
export const GET_PAY_OFF_SUCCESS = 'GET_PAY_OFF_SUCCESS';
export const GET_PAY_OFF_FAILED = 'GET_PAY_OFF_FAILED';

export const EMPYT_CHART_SUCCESS = 'EMPYT_CHART_SUCCESS';


export const USER_SINGUP_REQUEST = "GET_USER_SIGNUP_REQUEST";
export const USER_SINGUP_SUCCESS = "GET_USER_SIGNUP_SUCCESS";
export const USER_SINGUP_FAILED = "GET_USER_SIGNUP_FAILED";

export const VERIFY_OTP_REQUEST = 'VERIFY_OTP_REQUEST';
export const VERIFY_OTP_SUCCESS = 'VERIFY_OTP_SUCCESS';
export const VERIFY_OTP_FAILED = 'VERIFY_OTP_FAILED';

export const VERIFY_USER_LOGIN_REQUEST = "VERIFY_USER_LOGIN_REQUEST";
export const VERIFY_USER_LOGIN_SUCCESS = "VERIFY_USER_LOGIN_SUCCESS";
export const VERIFY_USER_LOGIN_FAILED = "VERIFY_USER_LOGIN_FAILED";

export const UPDATE_PROFILE_REQUEST = "UPDATE_PROFILE_REQUEST";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_FAILED = "UPDATE_PROFILE_FAILED";

export const LOGOUT_REQUEST = "LOGOUT_USER";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILED = "LOGOUT_FAILED";

export const TOKEN_EXPIRY = 'TOKEN_EXPIRY';
export const CLOSE_TOKEN_EXPIRY = 'CLOSE_TOKEN_EXPIRY';

export const DISPLAY_PROFILE_REQUEST = 'DISPLAY_PROFILE_REQUEST';
export const DISPLAY_PROFILE_SUCCESS = 'DISPLAY_PROFILE_SUCCESS';
export const DISPLAY_PROFILE_FAILED = 'DISPLAY_PROFILE_FAILED';

export const UPDATE_PASSWORD_REQUEST = "UPDATE_PASSWORD_REQUEST";
export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_FAILED = "UPDATE_PASSWORD_FAILED";

export const USER_PHONE_VERIFY_REQUEST = "USER_PHONE_VERIFY_REQUEST";
export const USER_PHONE_VERIFY_SUCCESS = "USER_PHONE_VERIFY_SUCCESS";
export const USER_PHONE_VERIFY_FAILED = "USER_PHONE_VERIFY_FAILED";

export const USER_PASSWORD_RESET_REQUEST = "USER_PASSWORD_RESET_REQUEST";
export const USER_PASSWORD_RESET_SUCCESS = "USER_PASSWORD_RESET_SUCCESS";
export const USER_PASSWORD_RESET_FAILED = "USER_PASSWORD_RESET_FAILED";